import {
  CRM_LEAD_VK_META_EMPTY,
  type CrmLeadVkInfo,
  type CrmLeadFunnelListItem,
} from '@/api/types/crm/crmLeadFunnels.types'

/**
 * Вложение `funnel_lead_list_item` с канбана: воронки приходят с `manager`,
 * в типе списка воронок CRM — `manager_id` у `CrmLeadFunnelShort`.
 */
export type KanbanFunnelLeadListItemApi = Omit<
  CrmLeadFunnelListItem,
  'funnels' | 'is_primary'
> & {
  is_primary?: boolean
  funnels: Array<{
    id: number
    name: string
    manager?: { id: number | null; fio?: string | null } | null
    next_contact_at?: string | null
    state?: string
    state_label?: string
  }>
  entered_at?: string
  vk?: CrmLeadVkInfo
  integrations?: import('@/api/types/crm/crmLeadFunnels.types').CrmLeadIntegrationsMap
}

export function mapKanbanFunnelLeadListItemToCrm(
  raw: KanbanFunnelLeadListItemApi,
): CrmLeadFunnelListItem {
  const funnels = (raw.funnels ?? []).map((f) => ({
    id: f.id,
    name: f.name,
    manager_id:
      f.manager != null &&
      f.manager.id != null &&
      Number.isFinite(Number(f.manager.id))
        ? Number(f.manager.id)
        : null,
  }))

  const leadId = raw.id ?? raw.lead?.id ?? 0

  return {
    id: leadId,
    lead_funnel_id: raw.lead_funnel_id,
    lead: raw.lead ?? {
      id: leadId,
      name: '',
      phone: '',
      email: null,
    },
    funnel: raw.funnel,
    current_status: raw.current_status,
    funnels,
    fields: raw.fields ?? [],
    manager: raw.manager,
    next_contact_date: raw.next_contact_date,
    is_primary: raw.is_primary ?? false,
    type: raw.type,
    vk: raw.vk ?? CRM_LEAD_VK_META_EMPTY,
    integrations: raw.integrations ?? {
      vkontakte: raw.vk ?? CRM_LEAD_VK_META_EMPTY,
    },
    traffic_channel: raw.traffic_channel,
    user_id: raw.user_id,
    user: raw.user,
    is_duplicate: raw.is_duplicate,
    last_duplicated_lead: raw.last_duplicated_lead,
    created_at: raw.created_at,
  }
}
